import { render } from "./dol-tree.vue?vue&type=template&id=a5d71cca"
import script from "./dol-tree.vue?vue&type=script&lang=js"
export * from "./dol-tree.vue?vue&type=script&lang=js"

import "./dol-tree.vue?vue&type=style&index=0&id=a5d71cca&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__